import { Component, OnInit } from '@angular/core';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-privacyPolicy',
    templateUrl: './privacyPolicy.component.html',
    styleUrls: ['./privacyPolicy.component.css'],
    imports: [WebNavbarComponent, WebFooterComponent]
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
